import React from "react"
import { inr } from "utils/formatters.utils"

const PaymentSummary = ({ due, paid }) => {
  return (
    <div className="w-1/2 text-base mb-6">
      <div className="grid grid-cols-12 gap-4 mb-2">
        <div className="col-span-3">Payment Due</div>
        <div className="col-span-1">:</div>
        <div className="col-span-8 vt-highlight">{inr(due)}</div>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-3">Total Paid</div>
        <div className="col-span-1">:</div>
        <div className="col-span-8 vt-highlight">{inr(paid)}</div>
      </div>
    </div>
  )
}

export default PaymentSummary
